export enum ChannelPlaylistsDisplayType {
    grid = "grid",
    player = "player",
}
